export var REDUX_FORM_NAME = 'record-form';



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-ui-materialui/node_modules/ra-core/esm/form/constants.js
// module id = 550
// module chunks = 0